import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "mx-16 mt-4 mb-2 p-4 bg-white relative main-table-view"
};
const _hoisted_2 = {
  class: "absolute text-green-400 rotate text-7xl opacity-40 uppercase bottom-[20%] left-[30%]"
};
const _hoisted_3 = {
  class: "flex flex-col justify-between"
};
const _hoisted_4 = {
  class: "flex flex-row justify-between pt-1"
};
const _hoisted_5 = {
  class: "flex flex-col"
};
const _hoisted_6 = {
  key: 0,
  class: "text-lg text-blue-300 uppercase"
};
const _hoisted_7 = {
  class: "flex flex-col"
};
const _hoisted_8 = {
  class: "text-gray-400 break-words uppercase"
};
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col"
};
const _hoisted_10 = {
  class: "py-2"
};
const _hoisted_11 = {
  class: "bg-invoice-row-light px-2 pb-1"
};
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col",
  "data-cy": "custom-fields-below-matter"
};
const _hoisted_13 = {
  class: "py-2"
};
const _hoisted_14 = {
  class: "flex justify-between bg-invoice-row-light px-2 pb-1"
};
const _hoisted_15 = {
  class: "lowercase"
};
const _hoisted_16 = {
  class: "py-2"
};
const _hoisted_17 = {
  class: "flex justify-between bg-invoice-row-dark",
  style: {
    "padding": "3px",
    "font-weight": "500"
  }
};
const _hoisted_18 = {
  class: "px-2"
};
const _hoisted_19 = {
  class: "flex justify-between bg-invoice-row-light px-2 pb-1"
};
const _hoisted_20 = {
  class: "py-2"
};
const _hoisted_21 = {
  class: "py-2"
};
const _hoisted_22 = {
  class: "py-2"
};
const _hoisted_23 = {
  class: "flex justify-between bg-invoice-row-light px-2 pb-1"
};
const _hoisted_24 = {
  "data-cy": "invoice-pdf-description-detail"
};
const _hoisted_25 = {
  class: "table",
  style: {
    "margin-bottom": "0.5rem",
    "border-bottom-width": "2px"
  }
};
const _hoisted_26 = {
  class: "bg-invoice-row-dark"
};
const _hoisted_27 = ["colspan"];
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = ["colspan"];
const _hoisted_30 = ["colspan"];
const _hoisted_31 = ["rowspan"];
const _hoisted_32 = {
  key: 2
};
const _hoisted_33 = {
  class: "flex justify-between text-sm font-bold"
};
const _hoisted_34 = {
  class: "flex justify-between pt-8"
};
const _hoisted_35 = {
  class: "w-4/12 px-2",
  "data-cy": "invoice-pdf-memo"
};
const _hoisted_36 = {
  class: "w-4/12 px-2 text-end"
};
const _hoisted_37 = {
  class: "py-2"
};
const _hoisted_38 = {
  class: "flex justify-between px-2 pb-1"
};
const _hoisted_39 = {
  class: "px-2"
};
const _hoisted_40 = {
  key: 0,
  class: "flex justify-between text-sm"
};
const _hoisted_41 = {
  key: 1,
  class: "flex justify-between text-sm"
};
const _hoisted_42 = {
  key: 0,
  class: "flex justify-between text-sm"
};
const _hoisted_43 = {
  key: 1,
  class: "flex justify-between text-sm"
};
const _hoisted_44 = {
  class: "py-2"
};
const _hoisted_45 = {
  class: "flex justify-between px-2 pb-1"
};
import InvoiceTableLogoAndHeader from '../InvoiceTableLogoAndHeader.vue';
import { convertNewlinesToBreaks } from '@/services/utils';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
import LlHtmlViewerIframe from '@/components/LlHtmlViewerIframe.vue';
import { computed } from 'vue';
export default {
  __name: 'InvoiceTemplateTable',
  props: {
    updatePdfState: {
      type: Object,
      required: true
    },
    serviceExpensePage: {
      type: Boolean,
      required: false,
      default: false
    },
    companyName: {
      type: String,
      required: false,
      default: ''
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      terms,
      features
    } = storeToRefs(useMeStore());
    const props = __props;
    const showCustomFieldsInHeader = computed(() => (!props.updatePdfState.showEnableCustomFieldsToggle || props.updatePdfState.enableCustomFields) && (!props.updatePdfState.showCustomFieldsBelowMatterName || !features.value.llCustomFieldPdf));
    const showCustomFieldsBelowMatter = computed(() => features.value.llCustomFieldPdf && props.updatePdfState.showCustomFieldsBelowMatterName && (props.updatePdfState.enableCustomFields || props.updatePdfState.enableMatterCustomFields));

    // When grouping is on, LedesCodeDescription is a fixed column that matches the printed invoice
    // header "Description". When grouping is off it is a user-selected column and should display
    // its own label so the admin can distinguish it from the regular Description column.
    const tableHeaderName = header => {
      if (header.fieldName === 'LedesCodeDescription') {
        return props.updatePdfState.groupingEnabled ? 'Description' : header.displayName;
      }
      return header.displayName;
    };
    const shouldShowInvoiceDescription = computed(() => {
      const desc = props.updatePdfState.invoicePdfDescription;
      // checkin if there invoicePdfDescription and it is not empty
      // desc.trim().length is for back tracking if users have templete created before this feature
      const hasValidDescription = typeof desc === 'string' && desc.trim().length > 0;
      return props.updatePdfState.enableInvoiceDescription && hasValidDescription;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, " paid ", 512), [[_vShow, __props.updatePdfState.enablePaidStamp && !__props.serviceExpensePage]]), _createElementVNode("div", _hoisted_3, [_createVNode(InvoiceTableLogoAndHeader, {
        contactInformation: __props.updatePdfState.contactInformation,
        companyName: __props.companyName,
        leanLawAuth: __props.leanLawAuth
      }, null, 8, ["contactInformation", "companyName", "leanLawAuth"]), _createElementVNode("span", _hoisted_4, [_createElementVNode("div", _hoisted_5, [!__props.serviceExpensePage && __props.updatePdfState.labelSettings.enableFormLabel ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.updatePdfState.labelSettings.formLabel), 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "text-gray-400 py-1"
      }, "BILL TO: ", -1)), _cache[1] || (_cache[1] = _createElementVNode("span", null, " Monica Geller ", -1)), _cache[2] || (_cache[2] = _createElementVNode("span", null, " 234 Lorem Street ", -1)), _cache[3] || (_cache[3] = _createElementVNode("span", null, " Appartement #20 ", -1)), _cache[4] || (_cache[4] = _createElementVNode("span", null, " New York, NY 10014, USA ", -1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, [_createElementVNode("span", _hoisted_8, _toDisplayString(__props.updatePdfState.labelSettings.formLabel), 1), _cache[5] || (_cache[5] = _createTextVNode(": 100 ", -1))]), _cache[7] || (_cache[7] = _createElementVNode("span", null, [_createElementVNode("span", {
        class: "text-gray-400"
      }, " Date: "), _createTextVNode(" 08/31/24")], -1)), _withDirectives(_createElementVNode("span", null, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
        class: "text-gray-400"
      }, "Due Date: ", -1), _createTextVNode(" 09/30/24 ", -1)]))], 512), [[_vShow, __props.serviceExpensePage || __props.updatePdfState.enableDueDate]])]), _createElementVNode("div", null, [showCustomFieldsInHeader.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.customFieldSettings, customFields => {
        return _openBlock(), _createElementBlock("span", {
          class: "mx-1",
          label: "",
          key: customFields.name
        }, _toDisplayString(customFields.name) + " : " + _toDisplayString(customFields.value), 1);
      }), 128))])) : _createCommentVNode("", true)])])]), !__props.serviceExpensePage ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", null, _toDisplayString(_unref(terms)?.Matter) + ": Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate est possimus, accusantium similique, illum repellat perspiciatis. ", 513), [[_vShow, __props.updatePdfState.enableMatterName]]), showCustomFieldsBelowMatter.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.customFieldSettings, customField => {
        return _openBlock(), _createElementBlock("span", {
          key: customField.name
        }, _toDisplayString(customField.name) + " : " + _toDisplayString(customField.value), 1);
      }), 128))])) : _createCommentVNode("", true)])]), _withDirectives(_createElementVNode("div", _hoisted_13, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "flex justify-between bg-invoice-row-dark",
        style: {
          "padding": "3px",
          "font-weight": "500"
        }
      }, [_createElementVNode("span", {
        class: "px-2"
      }, "Account Summary"), _createElementVNode("span", {
        class: "px-2"
      }, "Amount")], -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("div", null, "Balance Forward", -1)), _createElementVNode("div", null, [_cache[8] || (_cache[8] = _createTextVNode(" Payments and credits to this ", -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(__props.updatePdfState.labelSettings.formLabel), 1)]), _cache[10] || (_cache[10] = _createElementVNode("div", null, "New charges (detail below)", -1)), _cache[11] || (_cache[11] = _createElementVNode("div", null, "10% Discount", -1)), _createElementVNode("div", null, " Payment from " + _toDisplayString(__props.updatePdfState.displayTrustSummaryText ? 'trust' : 'retainer'), 1), _cache[12] || (_cache[12] = _createElementVNode("div", null, "Amount Due", -1))]), _cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "text-right"
      }, [_createElementVNode("div", null, "$23,000.00"), _createElementVNode("div", null, "0.0"), _createElementVNode("div", null, "$49,796.25"), _createElementVNode("div", null, "-$2,600.00"), _createElementVNode("div", null, "-$2,000.00"), _createElementVNode("div", null, "$68,196.25")], -1))])], 512), [[_vShow, __props.updatePdfState.accountSummary && !__props.updatePdfState.enableServiceExpenseByMatterPage]]), _withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(__props.updatePdfState.displayTrustSummaryText ? 'Trust' : 'Retainer') + " Summary", 1), _cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "px-2"
      }, "Amount", -1))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, [_createElementVNode("div", null, " Starting " + _toDisplayString(__props.updatePdfState.displayTrustSummaryText ? 'Trust' : 'Retainer') + " Balance ", 1), _createElementVNode("div", null, " Ending " + _toDisplayString(__props.updatePdfState.displayTrustSummaryText ? 'Trust' : 'Retainer') + " Balance ", 1), _createElementVNode("div", null, " Minimum " + _toDisplayString(__props.updatePdfState.displayTrustSummaryText ? 'Trust' : 'Retainer') + " Balance ", 1)]), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "text-right"
      }, [_createElementVNode("div", null, "$200,000.00"), _createElementVNode("div", null, "$8,000.00"), _createElementVNode("div", null, "$2,000.00")], -1))])], 512), [[_vShow, __props.updatePdfState.trustSummary]]), _withDirectives(_createElementVNode("div", _hoisted_20, [...(_cache[17] || (_cache[17] = [_createElementVNode("div", {
        class: "bg-invoice-row-dark p-[3px] font-medium"
      }, [_createElementVNode("span", {
        class: "px-2",
        "data-cy": "hour-summary-detail"
      }, "Hour Summary")], -1), _createElementVNode("div", {
        class: "bg-invoice-row-light px-2 pb-1"
      }, [_createElementVNode("div", null, "Gary Allen (GA): 5.00h @$500.00 = $2,500.00"), _createElementVNode("div", null, "Gabe Blanchet (GB): 9.00h @$200.00 = $1,800.00"), _createElementVNode("div", null, "Melissa Schaefers (MS): 1.70h @$200.00 = $340.00")], -1)]))], 512), [[_vShow, __props.updatePdfState.hourSummary && !__props.updatePdfState.enableServiceExpenseByMatterPage]]), _withDirectives(_createElementVNode("div", _hoisted_21, [...(_cache[18] || (_cache[18] = [_createStaticVNode("<div class=\"bg-invoice-row-dark p-[3px] font-medium\" data-v-7a04082f><span class=\"px-2\" data-cy=\"ledes-summary-detail\" data-v-7a04082f>LEDES Summary</span></div><div class=\"bg-invoice-row-light px-2\" data-v-7a04082f><div class=\"flex\" style=\"padding:3px 0;font-weight:500;border-bottom:2px solid #90a4ae;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>Code</span><span class=\"px-1 flex-[2]\" data-v-7a04082f>Description</span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>Hours</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>Amount</span></div><div class=\"flex\" style=\"padding:2px 0;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>A101</span><span class=\"px-1 flex-[2]\" data-v-7a04082f>Plan and prepare for</span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>1.50</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>$224.03</span></div><div class=\"flex\" style=\"padding:2px 0;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>A103</span><span class=\"px-1 flex-[2]\" data-v-7a04082f>Draft/revise</span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>0.30</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>$30.00</span></div><div class=\"flex\" style=\"padding:2px 0;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>A105</span><span class=\"px-1 flex-[2]\" data-v-7a04082f>Communicate (within legal team)</span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>2.00</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>$550.00</span></div><div class=\"flex\" style=\"padding:2px 0;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>A121</span><span class=\"px-1 flex-[2]\" data-v-7a04082f>Manage data/files</span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>0.50</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>$150.00</span></div><div class=\"flex font-bold\" style=\"padding:2px 0;border-top:1px solid #90a4ae;\" data-v-7a04082f><span class=\"px-1 flex-1\" data-v-7a04082f>Total</span><span class=\"px-1 flex-[2]\" data-v-7a04082f></span><span class=\"px-1 w-16 text-right\" data-v-7a04082f>4.30</span><span class=\"px-1 w-24 text-right\" data-v-7a04082f>$954.03</span></div></div>", 2)]))], 512), [[_vShow, _unref(features).codeSummary && __props.updatePdfState.ledesSummary && !__props.updatePdfState.enableServiceExpenseByMatterPage]]), _withDirectives(_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(__props.updatePdfState.invoicePdfDescription), 1)])], 512), [[_vShow, shouldShowInvoiceDescription.value]]), _createElementVNode("table", _hoisted_25, [_createElementVNode("thead", _hoisted_26, [_createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.tableFields, header => {
        return _openBlock(), _createElementBlock("th", {
          scope: "col",
          class: _normalizeClass(["text-black", {
            'table-number': header.fieldName == 'Amount' || header.fieldName == 'Rate' || header.fieldName == 'BilledHours' || header.fieldName == 'WriteDownHours'
          }]),
          style: {
            "padding": "3px",
            "font-weight": "500",
            "text-transform": "none"
          },
          key: header.fieldName
        }, _toDisplayString(tableHeaderName(header)), 3);
      }), 128))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.tableData, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [_createElementVNode("tr", null, [_createElementVNode("td", {
          colspan: __props.updatePdfState.tableFields.length,
          class: "gap-row"
        }, null, 8, _hoisted_27)]), item.subHeader ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [_createElementVNode("td", {
          colspan: __props.updatePdfState.tableFields.length,
          class: "bg-gray-100 text-left py-2 px-3 sub-header"
        }, _toDisplayString(item.subHeader), 9, _hoisted_29)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.lineItems, (lineItem, lineIndex) => {
          return _openBlock(), _createElementBlock("tr", {
            key: `${index}-${lineIndex}`,
            class: _normalizeClass({
              'font-bold': lineItem.subTotal === 'Sub-total',
              hidden: lineItem.subTotal === 'Sub-total' && !__props.updatePdfState.enableSubTotal
            })
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.tableFields, (header, headerIndex) => {
            return _openBlock(), _createElementBlock("td", {
              key: header.fieldName,
              class: _normalizeClass({
                'table-number': ['Amount', 'Rate', 'BilledHours', 'WriteDownHours'].includes(header.fieldName)
              })
            }, [headerIndex === 0 && __props.updatePdfState.enableSubTotal && lineItem.subTotal === 'Sub-total' && lineItem.Amount !== 0 ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "fon-bold table-number",
              colspan: __props.updatePdfState.tableFields.length
            }, " Sub total ", 8, _hoisted_30)) : _createCommentVNode("", true), header.fieldName === 'Matter' && lineIndex === 0 ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              rowspan: item.lineItems.length
            }, _toDisplayString(item[header.fieldName]), 9, _hoisted_31)) : header.fieldName !== 'Matter' ? (_openBlock(), _createElementBlock("span", _hoisted_32, [_createTextVNode(_toDisplayString(lineItem[header.fieldName]), 1), _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))])) : _createCommentVNode("", true)], 2);
          }), 128))], 2);
        }), 128))], 64);
      }), 128))])]), _createElementVNode("div", _hoisted_33, [_cache[23] || (_cache[23] = _createElementVNode("div", null, null, -1)), _cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "text-right"
      }, [_createElementVNode("div", null, "Sub Total"), _createElementVNode("div", null, "Tax"), _createElementVNode("div", null, "Total"), _createElementVNode("div", null, "Amount Due")], -1)), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("div", null, "$20,000.00", -1)), _cache[21] || (_cache[21] = _createElementVNode("div", null, "$200.00", -1)), _cache[22] || (_cache[22] = _createElementVNode("div", null, "$20,200.00", -1)), _createElementVNode("div", null, _toDisplayString(__props.updatePdfState.accountSummary ? '$68,196.25' : '$15,600.00'), 1)])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(__props.updatePdfState.memo), 1), _cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "w-4/12 px-2"
      }, null, -1)), _withDirectives(_createElementVNode("div", _hoisted_36, " 1/2 ", 512), [[_vShow, __props.updatePdfState.enablePageNumbers]])])], 64)) : _createCommentVNode("", true), __props.serviceExpensePage ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createVNode(LlHtmlViewerIframe, {
        htmlContent: _unref(convertNewlinesToBreaks)(__props.updatePdfState.openingParagraph)
      }, null, 8, ["htmlContent"])])], 512), [[_vShow, __props.updatePdfState.enableOpeningParagraph && __props.updatePdfState.openingParagraph.length]]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("div", {
        class: "bg-gray-200 underline"
      }, "Services", -1)), __props.updatePdfState.enableSegmentByPracticeArea ? (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[26] || (_cache[26] = [_createStaticVNode("<div data-v-7a04082f><div data-v-7a04082f>Services: Civil Litigation</div><div data-v-7a04082f>Services: Family Law</div><div class=\"py-2\" data-v-7a04082f>   </div></div><div data-v-7a04082f><div data-v-7a04082f>20.00 h</div><div data-v-7a04082f>10.00 h</div><div class=\"text-right py-2 font-bold pl-8\" data-v-7a04082f>Sub-total</div></div><div data-v-7a04082f><div data-v-7a04082f>$2,000.00</div><div data-v-7a04082f>$1,000.00</div><div class=\"py-2 font-bold\" data-v-7a04082f>$3,000.00</div></div>", 3)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[27] || (_cache[27] = [_createElementVNode("div", null, [_createElementVNode("div", {
        class: "py-2"
      }, "   ")], -1), _createElementVNode("div", null, [_createElementVNode("div", null, "30.00 h")], -1), _createElementVNode("div", null, [_createElementVNode("div", null, "$3,000.00")], -1)]))]))]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("div", {
        class: "bg-gray-200 underline"
      }, "Expenses", -1)), __props.updatePdfState.enableSegmentByType ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[29] || (_cache[29] = [_createStaticVNode("<div data-v-7a04082f><div data-v-7a04082f>Expenses: Private Investigators</div><div data-v-7a04082f>Expenses: Subpoena Fees</div><div class=\"py-2\" data-v-7a04082f>   </div></div><div data-v-7a04082f><div data-v-7a04082f>   </div><div data-v-7a04082f>   </div><div class=\"text-right py-2 font-bold pl-8\" data-v-7a04082f>Sub-total</div></div><div data-v-7a04082f><div data-v-7a04082f>$1,000.00</div><div data-v-7a04082f>$1,000.00</div><div class=\"py-2 font-bold\" data-v-7a04082f>$2,000.00</div></div>", 3)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[30] || (_cache[30] = [_createElementVNode("div", null, [_createElementVNode("div", {
        class: "py-2"
      }, "   ")], -1), _createElementVNode("div", null, [_createElementVNode("div", {
        class: "py-2"
      }, "   ")], -1), _createElementVNode("div", null, [_createElementVNode("div", null, "$2,000.00")], -1)]))]))]), _cache[32] || (_cache[32] = _createStaticVNode("<hr data-v-7a04082f><div class=\"flex justify-between text-sm font-bold\" data-v-7a04082f><div data-v-7a04082f>   </div><div class=\"text-right pl-8\" data-v-7a04082f><div data-v-7a04082f>Total Due</div><div data-v-7a04082f>Taxes</div><div data-v-7a04082f>Payments Received</div><div data-v-7a04082f>Amount Due</div></div><div class=\"text-right\" data-v-7a04082f><div data-v-7a04082f>$5,000.00</div><div data-v-7a04082f>$500.00</div><div data-v-7a04082f>$1,500.00</div><div data-v-7a04082f>$3,000.00</div></div></div>", 2))]), _withDirectives(_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createVNode(LlHtmlViewerIframe, {
        customContainerClass: 'iframeHeight',
        htmlContent: _unref(convertNewlinesToBreaks)(__props.updatePdfState.closingParagraph)
      }, null, 8, ["htmlContent"])])], 512), [[_vShow, __props.updatePdfState.enableClosingParagraph && __props.updatePdfState.closingParagraph.length]])], 64)) : _createCommentVNode("", true)]);
    };
  }
};